import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/curriculum';
export function PainPointsSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-117" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-118" data-mp="2wpknyo11gcsv">
        <h2 className="text-3xl font-black text-brand-deep md:text-4xl" data-id="element-119" data-mp="2wmyegiul7n80">🧬 Ti Riconosci in Queste Situazioni?</h2>
        <p className="mx-auto mt-4 max-w-2xl text-brand-gray" data-id="element-120" data-mp="2rsaxr65trx3z">
          Se una di queste ti suona familiare, non sei solo/a — è così per la maggior parte dei docenti di scienze.
        </p>
        <div className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-121" data-mp="30osdynt1ql6l">
          {painPoints.map(({
          icon: PointIcon,
          title,
          text
        }) => <article key={title} className="flex gap-4 rounded-2xl border border-brand-deep/[0.06] bg-brand-alt p-6 text-left shadow-sm" data-id="element-122" data-mp="3agpnlq4ep537">
              <PointIcon className="mt-0.5 h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-123" data-mp="3oduwdxvi8i25" />
              <div data-id="element-124" data-mp="3kcsu186ajpvy">
                <h3 className="text-base font-bold leading-snug text-brand-deep" data-id="element-125" data-mp="sv9ss2aij6g5">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-126" data-mp="ww3f4r8b4d6x">{text}</p>
              </div>
            </article>)}
        </div>
        <p className="mt-12 font-serif text-2xl font-bold italic text-brand-green" data-id="element-127" data-mp="11tv9rt0c6det">
          Meriti qualcosa di meglio di questo.
        </p>
      </Reveal>
    </section>;
}